import React from "react";
import {
  Box,
  SimpleGrid,
  useBreakpointValue,
} from "@chakra-ui/react";
import CaseStudies from "../Common/CaseStudiesGrid";
import { getStaticCaseStudyDescription } from "../../utils/caseStudyData";

const FilterableGrid = ({ caseStudies = [], loading, error }) => {

  const gridData = caseStudies && caseStudies.length > 0 
    ? caseStudies.map((study, index) => {
              
        let imageUrl = `/clients/cs0${(index % 9) + 1}.png`;
        
        if (study.cardImage?.url) {
          const baseUrl = process.env.REACT_APP_API_URL?.replace('/api', '');
          imageUrl = `${baseUrl}${study.cardImage.url}`;
        } else if (study.imageHeader?.headerImage?.url) {
          const baseUrl = process.env.REACT_APP_API_URL?.replace('/api', '');
          imageUrl = `${baseUrl}${study.imageHeader.headerImage.url}`;
        }
        
        let category = "Digital Solutions";
        if (study.categories && study.categories.length > 0) {
          category = "Government"; 
        }
        
        const title = study.imageHeader?.title || `Case Study ${study.id}`;
        
        // Check if this is a static case study and use static description
        const staticDescription = getStaticCaseStudyDescription(title);
        const description = staticDescription || 
                           study.projectInfo?.description || 
                           "Case study description not available";
        
        let keyResults = [];
        
        if (study.keyResults && Array.isArray(study.keyResults) && study.keyResults.length > 0) {
          keyResults = study.keyResults.slice(0, 4).map(result => {
            if (typeof result === 'string') {
              return result;
            } else if (typeof result === 'object') {
              return result.description || result.metric || result.title || result.result || result.text || result.name || 'Key Result';
            }
            return 'Key Result';
          }).filter(Boolean);
        } else if (study.Results && Array.isArray(study.Results) && study.Results.length > 0) {
          keyResults = study.Results.slice(0, 4).map(result => {
            if (typeof result === 'string') {
              return result;
            } else if (typeof result === 'object') {
              return result.title || result.description || result.result || 'Achievement';
            }
            return 'Achievement';
          }).filter(Boolean);
        }
        
        const transformedStudy = {
          id: study.id,
          documentId: study.documentId,
          slug: study.documentId, 
          image: imageUrl,
          title: title,
          description: description,
          results: keyResults,
          category: category,
          categoryColor: "blue",
        };
        
              return transformedStudy;
      })
    : [];


  const columns = useBreakpointValue({
    base: 1,
    md: 2,
    lg: 3,
  });

  if (loading) {
      return (
      <Box p={6} maxW="1400px" mx="auto">
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          minHeight: '200px' 
        }}>
          <div>Loading case studies...</div>
        </div>
      </Box>
    );
  }

  if (error) {
      return (
      <Box p={6} maxW="1400px" mx="auto">
        <div style={{ 
          display: 'flex', 
          flexDirection: 'column',
          justifyContent: 'center', 
          alignItems: 'center', 
          minHeight: '200px',
          color: 'red'
        }}>
          <div>❌ Error loading case studies:</div>
          <div>{error}</div>
          <div style={{ marginTop: '10px', fontSize: '0.9em', color: '#666' }}>
            Check console for more details
          </div>
        </div>
      </Box>
    );
  }

  if (!caseStudies || caseStudies.length === 0) {
      return (
      <Box p={6} maxW="1400px" mx="auto">
        <div style={{ 
          display: 'flex', 
          flexDirection: 'column',
          justifyContent: 'center', 
          alignItems: 'center', 
          minHeight: '200px' 
        }}>
          <div>📝 No case studies found</div>
          <div style={{ marginTop: '10px', fontSize: '0.9em', color: '#666' }}>
            Data count: {caseStudies?.length || 0}
          </div>
        </div>
      </Box>
    );
  }


  return (
    <Box p={6} maxW="1400px" mx="auto">
      {gridData.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '40px' }}>
          <div>📝 No case studies to display</div>
          <div style={{ marginTop: '10px', color: '#666' }}>
            Raw data: {JSON.stringify(caseStudies).substring(0, 200)}...
          </div>
        </div>
      ) : (
        <SimpleGrid columns={columns} spacing={6} mt={6}>
          {gridData.map((study, index) => (
            <CaseStudies 
              key={study.id || index} 
              study={study} 
              boxProps={{}}
            />
          ))}
        </SimpleGrid>
      )}
    </Box>
  );
};

export default FilterableGrid;
